import { Separator, Stack, Text } from '@fluentui/react';
import { SignatureView } from 'common/components/Signatures';
import { FlowApproval } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/FlowApproval';

export const Signatures: React.FC<{
  approvalDetails: FlowApproval | undefined;
  isNew: boolean;
}> = ({ approvalDetails, isNew }) => {
  const { nodes } = {
    ...approvalDetails?.approval?.approvalHistorySignaturesByEntityId,
  };


  return (
    <Stack>
      {approvalDetails?.approval?.approvalHistorySignaturesByEntityId.nodes
        .length! > 0 &&
        !isNew && (
          <Stack>
            <Separator />
            <Stack tokens={{ childrenGap: 20 }}>
              <Text variant="xLarge">Signatures</Text>
              <SignatureView signatureData={nodes!} />
            </Stack>
          </Stack>
        )}
    </Stack>
  );
};
